import { render, staticRenderFns } from "./createMusicScore.vue?vue&type=template&id=f7b591aa&"
import script from "./createMusicScore.vue?vue&type=script&lang=js&"
export * from "./createMusicScore.vue?vue&type=script&lang=js&"
import style0 from "./createMusicScore.vue?vue&type=style&index=0&id=f7b591aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports